import { useAuth } from "@/hooks/useAuth";
import { $api } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";

export const activityKeys = {
  all: ["get", "/api/v1/home/activity"] as const,
};

export function useHomeActivity() {
  const { backendToken } = useAuth();
  return $api.useQuery("get", "/api/v1/home/activity", undefined, {
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!backendToken,
  });
}
